// import { TranslatedContent } from '../../translations'; // Unused

// We can type this better later, for now we match the structure used in Navbar
export const getSolutionsData = (t: any) => {
    if (!t || !t.solutions) return [];

    return [
        {
            id: 'operations',
            name: t.solutions.operations?.title || 'Operations',
            registered: false,
            description: t.solutions.operations?.description || '',
            image: ''
        },
        {
            id: 'insights',
            name: t.solutions.insights?.title || 'Insights',
            registered: false,
            description: t.solutions.insights?.description || '',
            image: ''
        },
        {
            id: 'advisory',
            name: t.solutions.advisory?.title || 'Advisory',
            registered: false,
            description: t.solutions.advisory?.description || '',
            image: ''
        }
    ];
};

export const getAboutLinks = (t: any) => {
    if (!t || !t.navigation || !t.navigation.aboutSubmenu) return [];

    return [
        { id: 'overview', name: t.navigation.aboutSubmenu.overview, path: '/about/overview' },
        { id: 'board', name: t.navigation.aboutSubmenu.board, path: '/about/board' },
        { id: 'strategy', name: t.navigation.aboutSubmenu.strategy, path: '/about/strategy' }
        // { id: 'governance', name: t.navigation.aboutSubmenu.governance, path: '/about/governance' }
    ];
};
